const icons = require.context('icons', false, /\.*/);

export default {
  install: function (Vue, options) {
    Vue.prototype.$_getRandomId = function () {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return 'ID' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4();
    };

    Vue.prototype.$_getIcon = function (iconName) {
      //return iconName? (require.context('icons', false, iconName)):'';
      return iconName ? icons('./' + iconName) : '';
    };

    Vue.prototype.$_getSvg = function (iconName) {
      return require('icons/' + iconName);
    };

    (Vue.prototype.$_getModusContainer = function (el) {
      let out,
        parent = el.parentNode;
      while (parent && !out) {
        if (parent.className.match('ksm-modus__container')) {
          out = parent.parentNode;
        } else {
          parent = parent.parentNode;
        }
      }
      return out;
    }),
      //
      (Vue.prototype.$_extend = function (target, obj) {
        Object.keys(obj).forEach(k => {
          target[k] = obj[k];
        });
      }),
      //
      (Vue.prototype.$_modusChangeEvent = function (eventType, data) {
        let vue = this;
        vue.$store.dispatch(eventType, data).then(() => {
          if (data.stopUpdateUrl) {
            return;
          }
          const urlparams = vue.$store.getters['modus/getModusUrlparams'](data.modus);
          this.$router.push({
            query: urlparams,
            params: {
              modus: data.modus.id
            }
          });
        });
      }),
      //

      (Vue.prototype.$_findAncestor = function (el, className) {
        while ((el = el.parentElement) && !el.classList.contains(className));
        return el;
      }),
      //
      (Vue.prototype.$_getNewHtmlElement = function (htmlTxt, merz, doc, addLink) {
        let newDiv = document.createElement('div');
        newDiv.innerHTML = htmlTxt;
        //fields für Überprüfung
        const _source = doc._source;
        const kursivKeys = [
          'index_bildkuenstlerische_werke_14',
          'index_literarische_werke_13',
          'index_musikalische_werke_18',
          'index_publikationen_11',
          'index_zeitschriften_10',
          'index_zeitungen_17'
        ];
        let index_fields = [];
        let index_fields_kursiv = [];
        let notes_fields = [];
        let personIds = [];
        if (_source && _source['index_personenindex_8']) {
          personIds = _source['index_personenindex_8'];
          if (personIds) {
            personIds = personIds.map(p => p.ID);
          }
        }

        for (let key in _source) {
          let val = _source[key];
          if (key.match(/^index_/)) {
            index_fields = index_fields.concat(val);

            if (kursivKeys.indexOf(key) > -1) {
              //bestimmte index_ kursiv
              index_fields_kursiv = index_fields_kursiv.concat(val);
            }
          } else if (key == 'notes') {
            notes_fields = notes_fields.concat(val);
            //alle notes kursiv
            index_fields_kursiv = index_fields_kursiv.concat(val);
          }
        }

        const spans = newDiv.querySelectorAll('span');
        let merzListe = this.$store.getters.texte.merzListe;
        for (let si = 0, l = spans.length; si < l; si++) {
          let s = spans[si];
          // console.log(classNames);
          let classNames = s.className.trim().split(" ");
          for (let ci = 0; ci < classNames.length; ci++ ) {
          const className = classNames[ci];
          let a = document.createElement('a');
          let class_id = className.replace(/\D/g, '');
          let useFields;
          if (className.indexOf('index') > -1) {
            //-------------------- index ----------
            if (personIds.indexOf(class_id) > -1) {
              a.href = "#/personen?lemmaID=" + class_id;
            }
            useFields = index_fields;
          } else if (className.indexOf('notice') > -1) {
            //---------- notice ----------
            useFields = notes_fields;
          } else if (className.indexOf('doc') > -1 && merzListe) {
            //---------- doc ----------        
            let query = JSON.parse(JSON.stringify(this.$route.query)); //TODO
            let url = '';
            let modus;
            merzListe.forEach((_merz, i) => {
              //selbst nicht vergleichen
              if (_merz === merz || !merz) {
                modus = 'ansichtsmodus';
              } else {
                modus = 'vergleichsmodus';
              }
              _merz.seiten.forEach((seite, j) => {
                for (let id of seite.seiteIds) {
                  if (id == class_id) {
                    if (modus === 'ansichtsmodus') {
                      query.merzId = _merz.id;
                      query.seiteIdx = j;
                    } else {
                      query.b_merzId = _merz.id;
                      query.b_seiteIdx = j;
                    }

                    url = Object.keys(query)
                      .map(function (k) {
                        return encodeURIComponent(k) + '=' + encodeURIComponent(query[k]);
                      })
                      .join('&');
                    url = '#/texte/merzhefte/' + modus + '?' + url;
                  }
                }
              });
            });
            a.href = url;
            a.title = a.href;
          } else if (className.indexOf('id-http') > -1) {
            let isLink
            //---------- id-http ----------
            let href = className.replace(/^id-/, '');
            if (href.match(/zotero/)) {
              href = href.split('items/');
              href = '#/bibliographie/' + href[1].trim();
              a.title = 'Zur Bibliographie';
            } else {
              href = href.split(' ')[0];
              a.target = '_blank';
            }
            a.href = href;
          } else if (className.indexOf('id-mailto') > -1) {
            a.href = className.replace('id-','').trim();
            a.target = '_blank';
          }

          if (useFields) {
            let res = useFields.find(p => {
              return p.ID == class_id;
            });
            if (res) {
              a.title = res.content;
            }
          }
          if (useFields && index_fields_kursiv) {
            let res = index_fields_kursiv.find(p => {
              return p.ID - class_id === 0;
            });
            if (res) {
              a.classList.add('ksm-kursiv');
            }
          }
          if (!(addLink && a.href)) {
            if (a.className) {
              s.classList.add(a.className);
            }
          } else {
            s.parentNode.insertBefore(a, s);
            a.appendChild(s);
          }
        }
        }
        return newDiv;
      });
  }
};



// WEBPACK FOOTER //
// ./src/utils/mixin_plugin.js